// Vendor imports
const cookie = require('js-cookie')
// Client V1 imports
const { localStorage } = require('client/lib/storage')
// Client V2 common imports
const { showTooltip } = require('client-v2/common/containers/tooltips/actions')

// Tooltip action dispatchers

function showArticleCardCreateCollectionTooltip() {
  const key = 'article-card-create-collection'
  return function (dispatch, getState) {
    if (!isUserEligible() || isTooltipDismissed(key)) {
      return false
    }
    const { router, feed } = getState()
    // Only show the tooltip on logged-in-landing pages
    if (!router.action.startsWith('logged-in-landing.')) {
      return false
    }
    let uniqueId
    for (let item of feed.items) {
      // Only show the tooltip on the first article card
      if (item.type === 'article') {
        uniqueId = item.id
        break
      }
    }
    dispatch(showTooltip({
      key,
      uniqueId,
      title: 'Create a collection',
      body: `
        You can save posts into collections.
        Saved posts and collections will appear on your profile.
      `,
      onDismiss() { setTooltipDismissed(key) }
    }))
    return true
  }
}

function showCollectionProfileSubscribeTooltip() {
  const key = 'collection-profile-subscribe'
  return function (dispatch, getState) {
    if (!isUserEligible() || isTooltipDismissed(key)) {
      return false
    }
    const { user, collection, router } = getState()
    // Only show the tooltip on collection-profile posts page
    if (router.action !== 'collection-profile.showPosts') {
      return false
    }
    // Don't show the tooltip for yourself or if you're already subscribed
    if (user.id === collection['user_id'] || collection.isFollowing) {
      return false
    }
    dispatch(showTooltip({
      key,
      title: 'Subscribe',
      body: 'You’ll see new posts from this collection in your recommendations.',
      onDismiss() { setTooltipDismissed(key) }
    }))
    return true
  }
}

function showUserProfileFollowTooltip() {
  const key = 'user-profile-follow'
  return function (dispatch, getState) {
    if (!isUserEligible() || isTooltipDismissed(key)) {
      return false
    }
    const { user, profileUser, router } = getState()
    // Only show the tooltip on user-profile pages
    if (!router.action.startsWith('user-profile.')) {
      return false
    }
    // Don't show the tooltip for yourself or if you're already following the user
    if (user.id === profileUser.id || profileUser.isFollowing) {
      return false
    }
    dispatch(showTooltip({
      key,
      title: 'Follow',
      body: 'You’ll see more of this person’s posts & collections if you follow them.',
      onDismiss() { setTooltipDismissed(key) }
    }))
    return true
  }
}

module.exports = {
  showArticleCardCreateCollectionTooltip,
  showCollectionProfileSubscribeTooltip,
  showUserProfileFollowTooltip
}

// Helper functions

function isUserEligible() {
  return !!cookie.get('new_user_tooltips')
}

const dismissedKeys = new Set((() => {
  // Assign initial state from localStorage
  const valueStr = localStorage.getItem('new_user_tooltips')
  return Array.from(JSON.parse(valueStr || '[]'))
})())

function isTooltipDismissed(key) {
  return dismissedKeys.has(key)
}

function setTooltipDismissed(key) {
  dismissedKeys.add(key)
  const valueStr = JSON.stringify([...dismissedKeys])
  localStorage.setItem('new_user_tooltips', valueStr)
}
